import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InsightCard from './InsightCard';
import { evaluateInsights } from './insightRules';
import { useBudget } from '../../context/BudgetContext';

export default function SmartInsights() {
  const { t } = useTranslation();
  const { state, derived } = useBudget();
  const insights = evaluateInsights(state, derived);

  if (insights.length === 0) return null;

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2, color: '#1E3A5F' }}>
        {t('budgetPlanner.insights.title', 'Recomendaciones inteligentes')}
      </Typography>
      <Grid container spacing={2}>
        {insights.map((rule, index) => {
          const priority = index === 0 ? 'primary' : index === 1 ? 'secondary' : 'supporting';
          return (
            <Grid item xs={12} md={priority === 'primary' ? 12 : 6} key={rule.id}>
              <InsightCard rule={rule} priority={priority} />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
